import { usePagination } from "./usePagination.hook";
import { useSearch } from "./useSearch.hook";

/**
 * Combined hook for list components that handles both pagination and search
 * @param {number} initialPageSize - Initial page size (default: 10)
 * @returns {object} Combined pagination and search functionality
 */
export const useListControls = (initialPageSize = 10) => {
  const pagination = usePagination(initialPageSize);
  const search = useSearch(pagination.resetPage);

  return {
    // Pagination
    pagination: pagination.pagination,
    handlePageChange: pagination.handlePageChange,
    handlePageSizeChange: pagination.handlePageSizeChange,
    updateTotal: pagination.updateTotal,
    resetPage: pagination.resetPage,
    resetPagination: pagination.resetPagination,
    
    // Search
    search: search.search,
    handleSearch: search.handleSearch,
    resetSearch: search.resetSearch,
    
    // Combined operations
    resetAll: () => {
      pagination.resetPagination();
      search.resetSearch();
    },
  };
};